import { BaseResponse } from './internal/baseresponse';
export class UserRegisterResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/userregistresult.ts